import React from 'react'
import { Link, graphql } from 'gatsby'
import './ProductList.scss'
import RenderContent from '../../RenderContent'
import Pagination from '../Pagination'
import { FaChevronRight } from '../../../images/icons/FaChevronRight'
import ProductListItem from '../ProductListItem'
import { ProductListNavigation } from '../ProductListNavigation'
import AddToQuote from '../../Quote/AddToQuote'
import { Image } from '../../Image'
import FaTimes from '../../../images/icons/FaTimes'

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeProduct: null,
      activeImage: null,
    }
  }

  quickAdd = (event, data) => {
    this.setState({ activeProduct: data })
  }

  updateActiveImage = image => {
    if (image.source_url) {
      this.setState({ activeImage: image })
    }
  }

  closeModal = event => {
    event.preventDefault()
    this.setState({ activeProduct: null, activeImage: null })
  }

  showModal = activeProduct => {
    const { acf, wordpress_id, featured_media, title } = activeProduct
    const { activeImage } = this.state
    const { colours, productVariations } = acf
    const firstImage = activeImage ? activeImage : featured_media
    const productOptions = {
      colours: colours,
      variations: productVariations,
    }
    return (
      <div className="product-modal">
        <div className="wrap">
          <FaTimes
            className="close"
            onClick={event => this.closeModal(event)}
          />
          <div className="inner">
            <span
              className="product-title h1"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            {firstImage && (
              <div className="image">
                <div className="aspect">
                  <Image className="image" src={firstImage} lazyLoad={true} />
                </div>
              </div>
            )}
            <AddToQuote
              options={productOptions}
              productId={wordpress_id}
              updateActiveImage={this.updateActiveImage}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      posts,
      title,
      pageContext,
      categories,
      pathPrefix,
      siteMetadata,
      isParent,
    } = this.props
    const { activeProduct } = this.state

    return (
      <>
        <ProductListNavigation
          pathPrefix={pathPrefix}
          categories={categories}
          posts={posts}
          pageContext={pageContext}
        />
        {activeProduct && this.showModal(activeProduct)}
        {isParent ? null : (
          <section className="product-list">
            <div className="outer">
              <div className="wrap">
                <div className="inner">
                  <div className="list">
                    {posts.map(
                      (slide, inedx) =>
                        slide.node.slug !== 'gatsby' && (
                          <ProductListItem
                            key={inedx}
                            data={slide.node}
                            siteMetadata={siteMetadata}
                            pathPrefix={pathPrefix}
                            quickAdd={this.quickAdd}
                          />
                        )
                    )}
                  </div>
                  <Pagination
                    pageContext={pageContext}
                    pathPrefix={`${pathPrefix}`}
                  />
                </div>
              </div>
            </div>
          </section>
        )}
      </>
    )
  }
}

export const pageQuery = graphql`
  fragment ProductListFields on wordpress__wp_products {
    id
    wordpress_id
    product_category
    title
    excerpt
    date(formatString: "MMMM Qo gggg")
    slug
    path
    acf {
      colours {
        colourHex
        colourImage {
          source_url
        }
        colourName
      }
      productVariations {
        variationName
      }
      features {
        feature {
          label
          value
        }
        otherLabel
        otherValue
      }
      material
    }
    featured_media {
      source_url
      localFile {
        childImageSharp {
          fluid(maxWidth: 670) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  }
`
